import type * as React from 'react';
import type { FC } from 'react';

import Minus from '@crehana/icons/outline/Minus';
import Plus4 from '@crehana/icons/Plus4';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { colors } from '@crehana/ui';
import { clsx } from 'clsx';

interface CounterProps {
  count: number;
  maxCount?: number;
  minCount?: number;
  setCount: (value: number) => void;
  className?: string;
  disabled?: boolean;
}

const { primaryMain, grayMain } = colors;

const Counter: FC<React.PropsWithChildren<CounterProps>> = ({
  count,
  maxCount,
  minCount = 1,
  setCount,
  className,
  disabled,
}) => {
  const maxDisabled = disabled || (!!maxCount && maxCount === count);
  const minDisabled = disabled || count <= minCount;

  return (
    <div className={clsx('flex justify-between items-center w-120', className)}>
      <button
        type="button"
        className={clsx(
          'flex justify-center items-center p-8 rounded-5 border-2 border-solid',
          `${minDisabled ? 'border-gray-main' : 'border-primary-main'}`,
        )}
        onClick={() => setCount(count - 1)}
        disabled={minDisabled}
      >
        <Minus size={14} color={minDisabled ? grayMain : primaryMain} />
      </button>
      <span className="font-h4">{count}</span>
      <button
        type="button"
        className={clsx(
          'flex justify-center items-center p-8 rounded-5 border-2 border-solid',
          `${maxDisabled ? 'border-gray-main' : 'border-primary-main'}`,
        )}
        onClick={() => setCount(count + 1)}
        disabled={maxDisabled}
      >
        <Plus4 size={14} color={maxDisabled ? grayMain : primaryMain} />
      </button>
    </div>
  );
};

export default Counter;
